export default "__VITE_ASSET__BXXOIPEs__"